import { useState, useMemo } from "react";
import { subDays, endOfDay, addDays } from "date-fns";
import { AwakeWindowsChart } from "@/components/awake-windows-chart";
import { SleepChart } from "@/components/sleep-chart";
import type { SleepEvent, Child, SleepGoal } from "@/lib/types";
import { reconstructSleepPeriods } from "@/lib/timeline";

type HomeTabProps = {
  events: SleepEvent[];
  child?: Child;
  goal?: SleepGoal;
};

export function HomeTab({ events }: HomeTabProps) {
  const [timelineDate, setTimelineDate] = useState<Date>(new Date());
  
  const sleepPeriods = useMemo(() => {
    if (events.length === 0) return [];
    
    // Get a wider range of events to ensure we capture complete sleep periods
    // that might span across the selected date
    const startDate = subDays(timelineDate, 2); // Start 2 days before
    const endDate = endOfDay(addDays(timelineDate, 1)); // End 1 day after
    
    const relevantEvents = events.filter(e => {
        const eventDate = e.time.toDate();
        return eventDate >= startDate && eventDate <= endDate;
    });
    
    return reconstructSleepPeriods(relevantEvents);
  }, [events, timelineDate]);

  return (
    <div className="flex-1 p-4 space-y-6">
      <AwakeWindowsChart periods={sleepPeriods} events={events} selectedDate={timelineDate} onDateChange={setTimelineDate} />
      <SleepChart periods={reconstructSleepPeriods(events)} />
    </div>
  );
}
